import React from 'react';
import { WalletType } from '../types/wallet';
// @ts-ignore
import logo from '../image/logo.png';

interface HeaderProps {
  isConnected: boolean;
  address: string | undefined;
  walletType: WalletType;
  onDisconnect: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  isConnected,
  address,
  walletType,
  onDisconnect,
}) => {
  return (
    <header className="bg-gray-800 border-b border-gray-700 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3 sm:py-4">
          <img src={logo} alt="OneTapSell" className="h-8 sm:h-10 md:h-12 w-auto" />
          <div>
            {isConnected ? (
              <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
                <span className="text-xs uppercase tracking-wide bg-gray-700 text-gray-200 px-2 py-1 rounded">
                  {walletType === 'SOL' ? 'Solana' : walletType === 'SUI' ? 'Sui' : 'EVM'}
                </span>
                <span className="text-xs sm:text-sm text-gray-300 font-mono hidden sm:inline">
                  {address?.slice(0, 6)}...{address?.slice(-4)}
                </span>
                <span className="text-xs text-gray-300 font-mono inline sm:hidden">
                  {address?.slice(0, 4)}...{address?.slice(-3)}
                </span>
                <button
                  onClick={onDisconnect}
                  className="px-3 sm:px-4 py-2 bg-red-600 hover:bg-red-700 active:bg-red-800 rounded-lg text-xs sm:text-sm font-medium min-h-[44px] sm:min-h-[48px] transition-colors"
                >
                  <span className="hidden sm:inline">Disconnect</span>
                  <span className="sm:hidden">Disco</span>
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </header>
  );
};
